module.exports = __webpack_public_path__ + "img/user_icon.c4ffa008.svg";